import React from "react"
import { HUtils } from "@macashipo/mlib"
import NumeralJs from "src/libs/NumeralJs/numeral"
import HelperMore from "./_helperMore"
const BaseText = props => {
  const more = HelperMore.getMoreFromProps(props)
  const [isFocus, setIsFocus] = React.useState(false)
  const value = props.value
  const refValue = React.useRef(value)

  const getFormat = () => {
    return HUtils.runFuntion(props.fnList, "getFormat", []) || "0,0.[00]"
  }
  const getTypeInput = () => {
    return HUtils.runFuntion(props.fnList, "getTypeInput", []) || "text"
  }
  const fnFormatDefault = v => {
    return NumeralJs(v).format(getFormat())
  }
  const fnFormat =
    HUtils.runFuntion(props.fnList, "fnFormat", []) || fnFormatDefault
  let valueDisplay = fnFormat(value)
  // console.warn("render numeral valueDisplay:", valueDisplay)
  const checkCanNotPress = (key = "") => {
    if (value) {
      let _sValue = String(value)
      if (key === "-" && _sValue.indexOf("-") > -1) {
        return true
      }
      if (key === "." && _sValue.indexOf(".") > -1) {
        return true
      }
    }
    if (!/[0-9\-\.]/.test(key)) {
      return true
    }
    return false
  }
  const checkReplace = (newValue = "") => {
    if (newValue.indexOf("-") > -1 && newValue.indexOf("-") > 0) {
      newValue = newValue.replace("-", "")
      newValue = `-${newValue}`
    }
    if (newValue.indexOf(".") > -1) {
      if (newValue.indexOf(".") == 0) {
        newValue = `0${newValue}`
      }
      if (newValue.length > 1 && newValue.indexOf(".") == newValue.length) {
        newValue = `0${newValue}`
      }
    }
    return newValue
  }

  let _prefix = HelperMore.getPrefix(more)
  if (_prefix) {
    valueDisplay = _prefix + valueDisplay
  }
  let _suffix = HelperMore.getSuffix(more)
  if (_suffix) {
    valueDisplay += _suffix
  }

  if (value === "") {
    //== se bi truong hop 0 == "" => valueDisplay se bi rong
    valueDisplay = ""
  }
  let Tag = "input"
  if (getTypeInput() === "textarea") {
    Tag = "textarea"
  }
  // console.warn("render numeral", isFocus, props.value, valueDisplay)
  let _valueShowWhenFocus = value
  if (_valueShowWhenFocus === 0) {
    _valueShowWhenFocus = ""
  }
  // console.warn("render numeral:", props, _valueShowWhenFocus, valueDisplay)
  return (
    <Tag
      type={getTypeInput()}
      value={isFocus ? _valueShowWhenFocus : valueDisplay}
      onChange={ev => {
        let _value = checkReplace(ev.currentTarget.value)
        refValue.current = _value
        props.onChange && props.onChange(_value)
      }}
      onKeyPress={ev => {
        if (checkCanNotPress(ev.key)) {
          ev.preventDefault()
        }
      }}
      onFocus={() => {
        setIsFocus(true)
      }}
      onBlur={() => {
        setIsFocus(false)
        props.onBlur && props.onBlur(refValue.current)
      }}
      // onKeyDown={()=>{
      // }}
      className={props.className}
      style={props.style}
      {...props.attrs}
    />
  )
}

export default BaseText
